<template>
    <div class="CommandSearch">
        <Form ref="commandSearchForm" :model="commandSearchForm" :rules="ruleValidate">
            <Row :gutter="4">
                <Col span="5">
                    <FormItem prop="accountIdSearchKey">
                        <Select v-model="commandSearchForm.accountIdSearchKey" filterable :placeholder="$t('PatchEasy.PatchCmd.selectByAccount')"  @on-change="changeAccountId(commandSearchForm.accountIdSearchKey)" :transfer="true">
                            <Option :value="item.id" v-for="item in accountIdList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="5">
                    <FormItem prop="regionSearchKey">
                        <Select v-model="commandSearchForm.regionSearchKey" filterable :placeholder="$t('PatchEasy.PatchCmd.selectByRegion')" :transfer="true">
                            <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="5">
                    <Input search v-model="commandId" :placeholder="$t('PatchEasy.PatchCmd.selectByCmdID')"/>
                </Col>
                <Col span="5">
                    <Button type="primary" :loading="modal_loading" @click="search('commandSearchForm')" v-hasPermission="['patchManagement:patchCommandParameters:search']">{{$t('PatchEasy.PatchCmd.search')}}</Button>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
    import TableCommand from '../patch_command_parameters/TableCommand'
    var tableCommand = TableCommand;
    export default {
        name: 'CommandSearch',
        data () {
            return {
                commandSearchForm: {
                    accountIdSearchKey:'',
                    regionSearchKey:''
                },
                modal_loading:false,
                commandId:'',
                accountIdList:[], //账号
                regionList:[], //区域
                ruleValidate: {
                    accountIdSearchKey: [
                        { required: true, message: this.$t('alarms.common.pleaseSelectAccount'), trigger: 'change',type:'number' }
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ]
                }
            }
        },
        mounted: function(){
            this.selectAccountByCloudPlatform();
        },
        methods: {
            /**********************账号********************************/
            //查询账号
            selectAccountByCloudPlatform: function(){
                this.$api.account.selectAccountByCloudPlatform("type",0)
                .then(res => {
                    this.accountIdList = res.data;
                })
            },
            // 按账号筛选
            changeAccountId: function(){
                this.commandSearchForm.regionSearchKey='';
                this.queryAccountRegions();
            },
            /**********************区域********************************/
            //查询地区
            queryAccountRegions: function(){
                this.$api.account.queryAccountRegions("accountId",this.commandSearchForm.accountIdSearchKey)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            /**********************搜索********************************/
            search: function (name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        tableCommand.methods.showAll(this.commandSearchForm.accountIdSearchKey,this.commandSearchForm.regionSearchKey,this.commandId);
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .CommandSearch
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/patch_command_parameters/CommandSearch.vue